export default __webpack_public_path__ + "static/media/MGM20230913.0ac5df92.jpg";